/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyActionPair {
    getFixupPrototypeFunction() { return PolicyActionPair.fixupPrototype; }

    static newInstance(model: Partial<PolicyActionPair>): PolicyActionPair {
        let obj = Object.assign(new PolicyActionPair(), model);
        PolicyActionPair.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyActionPair>): PolicyActionPair {
        if (!model) return null;
        return PolicyActionPair.newInstance(<PolicyActionPair> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyActionPair) {
        if (!obj) return;

        models.PolicyActionPair.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyActionPair): boolean {
        Object.setPrototypeOf(obj, PolicyActionPair.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the policy
     */
    policy: models.PolicyEnum;

    /**
     * Action supported for the policy
     */
    action: models.ActionEnum;

}
